export class AdminSubscriptionCompanyProfile {
  cnpj: string

  socialReason: string

  stateRegistration: string

  slug: string

  companyMessage: string

  timeZoneId: string

  constructor(data: Partial<AdminSubscriptionCompanyProfile> = {}) {
    this.cnpj = data.cnpj ?? ""

    this.socialReason = data.socialReason ?? ""

    this.stateRegistration = data.stateRegistration ?? ""

    this.slug = data.slug ?? ""

    this.companyMessage = data.companyMessage ?? ""

    this.timeZoneId = data.timeZoneId ?? ""
  }
}
